var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.667 512C294.051 512 289.559 510.503 285.867 507.733L200.533 443.733C197.884 441.746 195.733 439.169 194.252 436.207C192.771 433.245 192 429.979 192 426.667V306.773L42.3254 138.389C31.6954 126.397 24.7548 111.591 22.3377 95.749C19.9207 79.9073 22.13 63.7046 28.7003 49.0883C35.2705 34.472 45.922 22.0642 59.3746 13.3561C72.8271 4.64795 88.5083 0.0101209 104.533 0L407.467 0C423.49 0.0187958 439.168 4.66431 452.615 13.3783C466.062 22.0922 476.707 34.5039 483.27 49.1218C489.833 63.7397 492.035 79.9419 489.612 95.7813C487.189 111.621 480.244 126.423 469.611 138.411L320 306.773V490.667C320 496.325 317.752 501.751 313.752 505.752C309.751 509.752 304.325 512 298.667 512V512ZM234.667 416L277.333 448V298.667C277.338 293.443 279.258 288.403 282.731 284.501L437.781 110.059C442.952 104.215 446.325 97.0035 447.497 89.2896C448.67 81.5758 447.591 73.6875 444.39 66.5719C441.189 59.4562 436.002 53.4156 429.453 49.1752C422.903 44.9348 415.269 42.6749 407.467 42.6667H104.533C96.735 42.6785 89.1056 44.9397 82.5601 49.179C76.0147 53.4184 70.8311 59.4559 67.6311 66.5675C64.4311 73.6791 63.3506 81.5628 64.519 89.2732C65.6875 96.9835 69.0553 104.193 74.2187 110.037L229.291 284.501C232.756 288.406 234.668 293.446 234.667 298.667V416Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8d4ddb22cd6042fcf9649a09b1777992.svg";
export { ForwardRef as ReactComponent };